<template>
  <v-container fluid>
    <v-row class="px-0 py-0 my-0">
      <v-col cols="12" class="d-md-flex">
        <RangeFilter
          :end="dateEnd"
          :start="dateStart"
          @getDates="getDates"
          :excludePeriod="excludePeriod"
          :defaultPeriod="defaultPeriod"
          :setDates="true"
          :disabled="loadedStatistic"
        />
        <v-switch
          v-model="isCompareFilter"
          hide-details
          color="orange darken-3"
          class="mx-5 mt-md-1 my-3 mb-md-0"
        >
          <template #label>
            <span class="ml-1">Compare</span>
          </template>
        </v-switch>
        <CompareFilter
          v-if="isCompareFilter"
          :end="dateCompareEnd"
          :start="dateCompareStart"
          :periodStart="dateStart"
          :periodEnd="dateEnd"
          @getDates="getCompareDates"
          :bgColor="compareFilterColor"
          :filterIcon="compareIcon"
          :diffDays="diffDays"
          :disabled="loadedStatisticCompare"
        />
      </v-col>
    </v-row>
    <v-card class="elevation-2 py-1 px-6 mt-4 rounded-lg">
      <v-row class="pa-0">
        <v-progress-linear indeterminate color="indigo" v-if="loadedStatistic || loadedStatisticCompare"></v-progress-linear>
        <v-col cols="12" md="6" lg="3" class="d-flex justify-start justify-lg-center" v-for="(e, i) in statisticСards" :key="e.value">
          <div class="d-flex flex-column">
            <div class="d-flex" v-for="card in statisticСards[i]" :key="card.value">
              <b class="pr-1">{{card.title}}: </b>
              <span v-if="!(card.loaded === 'loadedStatistic' ? loadedStatistic : loadings[card.loaded]) && card.filter === 'formatPrice' && card.value != 'costOther'">${{ statistic[card.value] | formatPrice }}</span>
              <span v-if="!(card.loaded === 'loadedStatistic' ? loadedStatistic : loadings[card.loaded]) && card.filter === 'formatFloat' && card.value != 'costOther'">{{ statistic[card.value] | formatFloat }}</span>
              <span v-if="!(card.loaded === 'loadedStatistic' ? loadedStatistic : loadings[card.loaded]) && card.value === 'costOther'">-</span>
              <div class="ml-1 align-self-center compare-text green--text text--darken-3" v-if="statisticCompare[card.value] > 0 && isCompareFilter && !loadedStatisticCompare">
                <span v-if="card.filter === 'formatFloat'"><v-icon class="compare-icon" color="green darken-2">mdi-arrow-up-thick</v-icon>{{ statisticCompare[card.value] | formatFloat }}</span>
                <span v-if="card.filter === 'formatPrice'"><v-icon class="compare-icon" color="green darken-2">mdi-arrow-up-thick</v-icon>{{ statisticCompare[card.value] | formatPrice }}</span>
              </div>
              <div class="ml-1 align-self-center compare-text red--text text--darken-3" v-if="statisticCompare[card.value] < 0 && isCompareFilter && !loadedStatisticCompare">
                <span v-if="card.filter === 'formatFloat'"><v-icon class="compare-icon" color="red darken-2">mdi-arrow-down-thick</v-icon>{{ statisticCompare[card.value] | formatFloatAbs }}</span>
                <span v-if="card.filter === 'formatPrice'"><v-icon class="compare-icon" color="red darken-2">mdi-arrow-down-thick</v-icon>{{ statisticCompare[card.value] | formatPriceAbs }}</span>
              </div>
              <div class="ml-1 align-self-center compare-text blue--text text--darken-3" v-if="card.value != 'costOther' && statisticCompare[card.value] == 0 && isCompareFilter && !loadedStatisticCompare">0</div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
      <last-time-updated :selectedDate="'updateGoogleAds'" class="mr-2 mt-3"/>
      <v-row class="px-2">
        <v-col cols="4" class="py-0 d-flex">
          <h2 class="pl-3">Google Ads</h2>
        </v-col>
        <v-col cols="8" class="py-0 d-flex justify-end justify-md-end">
          <v-spacer></v-spacer>
          <vue-excel-xlsx
            :data="dataAdwordsForExcel"
            :columns="columnsDataAdwords"
            :filename="'Adwords_efficiency_report'"
            :sheetname="`${dateStart} ~ ${dateEnd}`"
            >
              <v-btn
                height="39"           
                min-width="39px"        
                :disabled="dataAdwords.length === 0"
                class="ml-auto mr-5 rounded-lg px-0"                           
                color="white"
              >
                <ExportExcel />
              </v-btn> 
          </vue-excel-xlsx>
          <CustomColumns 
            :currentValue="valueAdwords"
            :currentCustomHeader="customHeaderAdwords"
            :currentHeaders="headersAdwords"
            :settingsName="`${settingsName}Adwords`"
            @getCustomData="getCustomDataAdwords"
          />
        </v-col>
      </v-row>
      <v-hover v-model="hoverOnTableAdwords">
        <v-card-text>
          <div class="d-flex justify-space-between">        
            <v-btn
              class="mx-2 scroll-btn btn-left-arrow-adw"
              fab
              small     
              @click="scrollingLeftAdw"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2 scroll-btn btn-right-arrow-adw"
              fab
              small
              @click="scrollingRightAdw"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table id="id_table_google_ads"
            :footer-props="{
                'items-per-page-options': [10, 25, 50, 75, 100, -1]
                }"
            :items-per-page="10"              
            dense
            :headers="selectedHeadersAdwords"
            :items="dataAdwords"
            :page.sync="pagination.page"
            item-key="campaignName"
            class="elevation-0 mt-2 table-main-container"
            fixed-header
            height="401"
            :loading="loadings.loadedAdwords || loadings.loadedAdwordsCompare"
            loading-text="Loading... Please wait"
            :custom-sort="customSort"
            @click:row="rowClick"
          >
            <template  v-for="e in slotsAdwordsBing" v-slot:[`item.${e.name}`]="{ item }">
              <div class="d-flex flex-column align-end align-md-center"  :key="e.name">
                <div v-if="e.filter=='formatFloat' && (!e.redirect || item[`${e.name}`]==0)">{{ item[`${e.name}`] | formatFloat }}</div>
                <div v-if="e.filter=='formatPrice'">${{ item[`${e.name}`] | formatPrice }}</div>
                <a v-if="item[`${e.name}`]>0 && e.redirect" @click="redirectToSalesReport(item, 'Adwords')">{{ item[`${e.name}`] | formatFloat }}</a>
                
                <div v-if="item[`${e.name}Compare`] > 0 && isCompareFilter && !loadings.loadedAdwordsCompare" class="d-inline-flex compare-text green--text text--darken-3">
                  <v-icon class="compare-icon" color="green darken-2">mdi-arrow-up-thick</v-icon>
                  <span v-if="e.filter=='formatFloat'" class="ml-0">{{ item[`${e.name}Compare`] | formatFloat }}</span>
                  <span v-if="e.filter=='formatPrice'" class="ml-0">{{ item[`${e.name}Compare`] | formatPrice }}</span>
                </div>
                <div v-if="item[`${e.name}Compare`] < 0 && isCompareFilter && !loadings.loadedAdwordsCompare" class="d-inline-flex compare-text red--text text--darken-3">
                  <v-icon class="compare-icon" color="red darken-2">mdi-arrow-down-thick</v-icon>
                  <span v-if="e.filter=='formatFloat'" class="ml-0">{{ item[`${e.name}Compare`] | formatFloatAbs }}</span>
                  <span v-if="e.filter=='formatPrice'" class="ml-0">{{ item[`${e.name}Compare`] | formatPriceAbs }}</span>
                </div>
                <div v-if="item[`${e.name}Compare`] == 0 && isCompareFilter && !loadings.loadedAdwordsCompare" class="compare-text blue--text text--darken-3">0</div>
                <div v-if="item[`${e.name}Compare`] == 0 && isCompareFilter && !loadings.loadedAdwordsCompare" class="compare-text blue--text text--darken-3">0</div>
              </div>
            </template>
              <template v-slot:item.campaignName="{ item }">
                  <!-- <span><a target="_blank" :href="`https://my.sendinblue.com/camp/report/id/`+item.id ">{{item.campaignName}}</a></span> -->
                  <span><button class="btn btn-link" v-on:click="handlerClickCampaingName(item.campaignName)" > {{item.campaignName}} </button></span>

              </template>
            <template v-slot:item.roas="{item}">
              <span>{{floatToString(item.roas)}}</span>

            </template>
            <template v-slot:item.totalCalls="{ item }">
              <a v-if="item.totalCalls.length>0" @click="showSimpleAlert(item, 'call')">{{ item.totalCalls.length }}</a>
              <span v-else>0</span>
            </template>
            <template v-slot:item.totalWebInq="{ item }">
              <a v-if="item.totalWebInq.length>0" @click="showSimpleAlert(item, 'web')">{{ item.totalWebInq.length }}</a>
              <span v-else>0</span>
            </template>



          </v-data-table>
        </v-card-text>
      </v-hover>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
      <last-time-updated :selectedDate="'updateBingAds'" class="mr-2 mt-3"/>
      <v-row class="px-2">
        <v-col cols="4" class="py-0 d-flex">
          <h2 class="pl-3">Bing Ads</h2>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="8" class="py-0 d-flex justify-end justify-md-end">
          <v-spacer></v-spacer>
          <vue-excel-xlsx
            :data="dataBingForExcel"
            :columns="columnsDataBing"
            :filename="'Bing_efficiency_report'"
            :sheetname="`${dateStart} ~ ${dateEnd}`"
            >
              <v-btn
                height="39"           
                min-width="39px"        
                :disabled="dataBing.length === 0"
                class="ml-auto mr-5 rounded-lg px-0"                           
                color="white"
              >
                <ExportExcel />
              </v-btn> 
          </vue-excel-xlsx>
          <CustomColumns 
            :currentValue="valueBing"
            :currentCustomHeader="customHeaderBing"
            :currentHeaders="headersBing"
            :settingsName="`${settingsName}Bing`"
            @getCustomData="getCustomDataBing"
          />
        </v-col>
      </v-row>
      <v-hover v-model="hoverOnTableBing">
        <v-card-text>
          <div class="d-flex justify-space-between">        
            <v-btn
              class="mx-2 scroll-btn btn-left-arrow-bing"
              fab
              small     
              @click="scrollingLeftBing"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2 scroll-btn btn-right-arrow-bing"
              fab
              small
              @click="scrollingRightBing"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
            <v-data-table id="id_bind_ads"
            :footer-props="{
                'items-per-page-options': [10, 25, 50, 75, 100, -1]
                }"
            :items-per-page="10"
            class="elevation-0 mt-2 table-main-container"
            fixed-header
            height="401"
            dense
            :headers="selectedHeadersBing"
            :items="dataBing"
            :page.sync="pagination.page"
            item-key="campaignName"
            :loading="loadings.loadedBing || loadings.loadedBingCompare"
            loading-text="Loading... Please wait"
            :custom-sort="customSort"
            @click:row="rowClick"
          >
          <template  v-for="e in slotsAdwordsBing" v-slot:[`item.${e.name}`]="{ item }">
              <div class="d-flex flex-column align-end align-md-center"  :key="e.name">
                <div v-if="e.filter=='formatFloat' && (!e.redirect || item[`${e.name}`]==0)">{{ item[`${e.name}`] | formatFloat }}</div>
                <div v-if="e.filter=='formatPrice'">${{ item[`${e.name}`] | formatPrice }}</div>
                <a v-if="item[`${e.name}`]>0 && e.redirect" @click="redirectToSalesReport(item, 'Bing')">{{ item[`${e.name}`] | formatFloat }}</a>
                
                <div v-if="item[`${e.name}Compare`] > 0 && isCompareFilter && !loadings.loadedBingCompare" class="d-inline-flex compare-text green--text text--darken-3">
                  <v-icon class="compare-icon" color="green darken-2">mdi-arrow-up-thick</v-icon>
                  <span v-if="e.filter=='formatFloat'" class="ml-0">{{ item[`${e.name}Compare`] | formatFloat }}</span>
                  <span v-if="e.filter=='formatPrice'" class="ml-0">{{ item[`${e.name}Compare`] | formatPrice }}</span>
                </div>
                <div v-if="item[`${e.name}Compare`] < 0 && isCompareFilter && !loadings.loadedBingCompare" class="d-inline-flex compare-text red--text text--darken-3">
                  <v-icon class="compare-icon" color="red darken-2">mdi-arrow-down-thick</v-icon>
                  <span v-if="e.filter=='formatFloat'" class="ml-0">{{ item[`${e.name}Compare`] | formatFloatAbs }}</span>
                  <span v-if="e.filter=='formatPrice'" class="ml-0">{{ item[`${e.name}Compare`] | formatPriceAbs }}</span>
                </div>
                <div v-if="item[`${e.name}Compare`] == 0 && isCompareFilter && !loadings.loadedBingCompare" class="compare-text blue--text text--darken-3">0</div>
              </div>
            </template>
              <template v-slot:item.campaignName="{ item }">
                  <!-- <span><a target="_blank" :href="`https://my.sendinblue.com/camp/report/id/`+item.id ">{{item.campaignName}}</a></span> -->
                  <span><button class="btn btn-link" v-on:click="handlerClickCampaingName(item.campaignName)" > {{item.campaignName}} </button></span>

              </template>
              <template v-slot:item.roas="{item}">
                <span>{{floatToString(item.roas)}}</span>

              </template>

              <template v-slot:item.totalWebInq="{ item }">
                <a v-if="item.totalWebInq.length>0" @click="showSimpleAlert(item, 'web')">{{ item.totalWebInq.length }}</a>
                <span v-else>0</span>
              </template>
              <template v-slot:item.totalCalls="{ item }">
                <a v-if="item.totalCalls.length>0" @click="showSimpleAlert(item, 'call')">{{ item.totalCalls.length }}</a>
                <span v-else>0</span>
              </template>


            </v-data-table>
        </v-card-text>
      </v-hover>
    </v-card>
    <v-card class="elevation-2 py-1 px-0 mt-4 rounded-lg">
      <last-time-updated :selectedDate="'updateOrders'" class="mr-2 mt-3"/>
      <v-row class="px-2">
        <v-col cols="12" sm="8" md="6" class="py-0 d-flex">
          <h2 class="pl-3 mr-4">Other</h2>
          <v-select
            v-model="selectedOtherMode"
            :items="otherMode"
            item-text="text"
            item-value="value"
            label="Created by Admin/User"
            multiple
            outlined
            dense
            hide-details
            @input="changeOtherMode"
          >
          </v-select>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="4" class="py-5 py-sm-0 d-flex justify-end justify-md-end">
          <v-spacer></v-spacer>
          <vue-excel-xlsx
            :data="dataOtherForExcel"
            :columns="columnsDataOther"
            :filename="'Other_efficiency_report'"
            :sheetname="`${dateStart} ~ ${dateEnd}`"
            >
              <v-btn
                height="39"           
                min-width="39px"        
                :disabled="dataOther.length === 0"
                class="ml-auto mr-5 rounded-lg px-0"                           
                color="white"
              >
                <ExportExcel />
              </v-btn> 
          </vue-excel-xlsx>
          <CustomColumns 
            :currentValue="valueOther"
            :currentCustomHeader="customHeaderOther"
            :currentHeaders="headersOther"
            :settingsName="`${settingsName}Other`"
            @getCustomData="getCustomDataOther"
          />
        </v-col>
      </v-row>
      <v-hover v-model="hoverOnTableOther">
        <v-card-text>
          <div class="d-flex justify-space-between">        
            <v-btn
              class="mx-2 scroll-btn btn-left-arrow-other"
              fab
              small     
              @click="scrollingLeftOther"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2 scroll-btn btn-right-arrow-other"
              fab
              small
              @click="scrollingRightOther"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>

          <v-dialog v-model="dialogSimple" max-width="38%">
            <v-card>
              <v-card-title class="d-flex flex-column align-start">
                <span v-if="dialogSimpleType == 'web'">Web Inquiries</span>
                <span v-else>Calls</span>
                <div class="d-flex">
                  <p class="text-subtitle-2 mt-1">Keyword: {{ selectedKeyword ? selectedKeyword.text : '' }}</p>
                </div>
              </v-card-title>
              <v-card-text>
                <div v-if="dialogSimpleType == 'web'">
                  <ul v-if="selectedKeyword">
                    <li v-for="item of selectedKeyword.totalWebInq" :key="item">{{item}}</li>
                  </ul>
                </div>
                <div v-else>
                  <ul v-if="selectedKeyword">
                    <li v-for="item of selectedKeyword.totalCalls" :key="item">
                      <a target="_blank" :href="`https://app.callrail.com/calls/${item.toString().trim()}`">{{item}}</a>
                    </li>
                  </ul>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn
                    color="indigo white--text"
                    text
                    @click="dialogSimple = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-data-table id="id_table_other"
            :footer-props="{
                'items-per-page-options': [10, 25, 50, 75, 100, -1]
                }"
            :items-per-page="10"
            dense
            :headers="selectedHeadersOther"
            :items="dataOther"
            :page.sync="pagination.page"
            class="elevation-0 mt-2 table-main-container"
            :loading="loadings.loadedOther || loadings.loadedOtherCompare"
            loading-text="Loading... Please wait"
            :custom-sort="customSort"
            @click:row="rowClick"
            item-key="name"
          >
            <template  v-for="e in slotsOther" v-slot:[`item.${e.name}`]="{ item }">
              <div class="d-flex flex-column align-end align-md-center"  :key="e.name">
                <div v-if="e.filter=='formatFloat' && (!e.redirect || item[`${e.name}`]==0)">{{ item[`${e.name}`] | formatFloat }}</div>
                <div v-if="e.filter=='formatPrice' && !e.redirect">${{ item[`${e.name}`] | formatPrice }}</div>
                <a v-if="item[`${e.name}`]>0 && e.redirect" @click="redirectToSalesReport(item, `${e.redirect}`)">{{ item[`${e.name}`] | formatFloat }}</a>
                
                <div v-if="item[`${e.name}Compare`] > 0 && isCompareFilter && !loadings.loadedOtherCompare" class="d-inline-flex compare-text green--text text--darken-3">
                  <v-icon class="compare-icon" color="green darken-2">mdi-arrow-up-thick</v-icon>
                  <span v-if="e.filter=='formatFloat'" class="ml-0">{{ item[`${e.name}Compare`] | formatFloat }}</span>
                  <span v-if="e.filter=='formatPrice'" class="ml-0">{{ item[`${e.name}Compare`] | formatPrice }}</span>
                </div>
                <div v-if="item[`${e.name}Compare`] < 0 && isCompareFilter && !loadings.loadedOtherCompare" class="d-inline-flex compare-text red--text text--darken-3">
                  <v-icon class="compare-icon" color="red darken-2">mdi-arrow-down-thick</v-icon>
                  <span v-if="e.filter=='formatFloat'" class="ml-0">{{ item[`${e.name}Compare`] | formatFloatAbs }}</span>
                  <span v-if="e.filter=='formatPrice'" class="ml-0">{{ item[`${e.name}Compare`] | formatPriceAbs }}</span>
                </div>
                <div v-if="item[`${e.name}Compare`] == 0 && isCompareFilter && !loadings.loadedOtherCompare" class="compare-text blue--text text--darken-3">0</div>
              </div>
            </template>
            <template v-slot:item.roas="{item}">
              <span>{{floatToString(item.roas)}}</span>
            </template>


          </v-data-table>
        </v-card-text>
      </v-hover>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import moment from 'moment'
import RangeFilter from '@/components/filters/RangePicker'
import CompareFilter from '@/components/filters/ComparePicker'
import CustomColumns from '@/components/customizing/CustomColumns'
import ExportExcel from '@/components/customizing/ExportExcel'
import LastTimeUpdated from "@/views/LastTimeUpdated"

// Marketing Channel Attribution class

export default {
    components: {
      LastTimeUpdated,
      RangeFilter,
      CompareFilter,
      CustomColumns,
      ExportExcel
    },
    data() {
      return {
        dateEnd: new Date().toISOString().substr(0, 10),
        dateStart: new Date(
                      Date.UTC(
                          new Date().getFullYear(),
                          new Date().getMonth(),
                          1)).toISOString().substr(0, 10),
                     
        excludePeriod: [],
        defaultPeriod: 4,
        dateCompareEnd: new Date(
                          Date.UTC(
                              new Date().getFullYear(),
                              new Date().getMonth(),
                              0
                              )).toISOString().substr(0, 10),
        dateCompareStart: new Date(
                            Date.UTC(
                                new Date().getFullYear(),
                                new Date().getMonth()-1,
                                0
                                )).toISOString().substr(0, 10), 
        diffDays: 0,
        compareFilterColor: 'orange darken-3',
        compareIcon: 'mdi-compare-vertical',
        isCompareFilter: false,
        pagination: {
          page: 1
        },
        loadings: {
          loadedAdwords: false,
          loadedBing: false,
          loadedOther: false,
          loadedAdwordsCompare: false,
          loadedBingCompare: false,
          loadedOtherCompare: false
        },

        dialogSimple: false,
        dialogSimpleType: "web", // or call
        selectedKeyword: null,


        dataAdwords: [],
        dataCompareAdwords: [],
        dataBing: [],
        dataCompareBing: [],
        dataOther: [],
        dataCompareOther: [],
        headersAdwords: [
          {text: 'Campaign Name', value: 'campaignName', class: 'black--text'},
          {text: 'Campaign Status', value: 'campaignStatus', class: 'black--text'},
          {text: 'Impressions', value: 'impressions', class: 'black--text'},
          {text: 'Clicks', value: 'clicks', class: 'black--text'},
          {text: 'Expenses', value: 'spend', class: 'black--text'},
          {text: 'CPC', value: 'avgCpc', class: 'black--text'},
          {text: 'Conversions', value: 'conversions', class: 'black--text'},
            {text: 'ROAS', value: 'roas', class: 'black--text',sortable: true},
          {text: 'Cost per Conversion', value: 'costPerConversion', class: 'black--text'},
          {text: 'Total Calls', value: 'totalCalls', class: 'black--text'},
          {text: 'Total Web Inquiries', value: 'totalWebInq', class: 'black--text'},
          {text: 'Gallons', value: 'gallons', class: 'black--text'},
          {text: 'Quoted Gallons', value: 'quoted_gallons', class: 'black--text'},
            {text: 'Potential Gallons', value: 'p_gallons', class: 'black--text'},
          {text: 'Revenue', value: 'salePrice', class: 'black--text'},
          {text: 'Return', value: 'return', class: 'black--text'},
          {text: 'Orders', value: 'orders', class: 'black--text'},
          {text: 'ROI', value: 'roi', class: 'black--text'},
        ],
        headersBing: [
          {text: 'Campaign Name', value: 'campaignName', class: 'black--text'},
          {text: 'Campaign Status', value: 'campaignStatus', class: 'black--text'},
          {text: 'Impressions', value: 'impressions', class: 'black--text'},
          {text: 'Clicks', value: 'clicks', class: 'black--text'},
          {text: 'Expenses', value: 'spend', class: 'black--text'},
          {text: 'CPC', value: 'avgCpc', class: 'black--text'},
          {text: 'Conversions', value: 'conversions', class: 'black--text'},
            {text: 'ROAS', value: 'roas', class: 'black--text',sortable: true},
          {text: 'Cost per Conversion', value: 'costPerConversion', class: 'black--text'},
          {text: 'Total Calls', value: 'totalCalls', class: 'black--text'},
          {text: 'Total Web Inquiries', value: 'totalWebInq', class: 'black--text'},
          {text: 'Gallons', value: 'gallons', class: 'black--text'},
          {text: 'Quoted Gallons', value: 'quoted_gallons', class: 'black--text'},

          {text: 'Potential Gallons', value: 'p_gallons', class: 'black--text'},
          {text: 'Revenue', value: 'salePrice', class: 'black--text'},
          {text: 'Return', value: 'return', class: 'black--text'},
          {text: 'Orders', value: 'orders', class: 'black--text'},
          {text: 'ROI', value: 'roi', class: 'black--text'}
        ],
        headersOther: [
          {text: 'Name', value: 'name', class: 'black--text'},
          {text: 'Admin Count Orders', value: 'countOrdersAdmin', class: 'black--text'},
          {text: 'Admin Gallons', value: 'gallonsAdmin', class: 'black--text'},
          {text: 'Admin Revenue', value: 'salePriceAdmin', class: 'black--text'},
          {text: 'User Count Orders', value: 'countOrdersUser', class: 'black--text'},
          {text: 'User Gallons', value: 'gallonsUser', class: 'black--text'},
          {text: 'User Revenue', value: 'salePriceUser', class: 'black--text'},
          {text: 'Total Count Orders', value: 'countOrdersTotal', class: 'black--text'},
          {text: 'Total Gallons',value: 'gallonsTotal', class: 'black--text'},
          {text: 'Total Calls', value: 'totalCalls', class: 'black--text'},
          {text: 'Total Web Inquiries', value: 'totalWebInq', class: 'black--text'},
          {text: 'Total Revenue',value: 'salePriceTotal', class: 'black--text'}
        ],
        valueAdwords: [
          {text: 'Campaign Name', value: 'campaignName', class: 'black--text'},
          {text: 'Campaign Status', value: 'campaignStatus', class: 'black--text'},
          {text: 'Impressions', value: 'impressions', class: 'black--text'},
          {text: 'Clicks', value: 'clicks', class: 'black--text'},
          {text: 'Expenses', value: 'spend', class: 'black--text'},
          {text: 'CPC', value: 'avgCpc', class: 'black--text'},
          {text: 'Conversions', value: 'conversions', class: 'black--text'},
            {text: 'ROAS', value: 'roas', class: 'black--text',sortable: true},
          {text: 'Cost per Conversion', value: 'costPerConversion', class: 'black--text'},
          {text: 'Total Calls', value: 'totalCalls', class: 'black--text'},
          {text: 'Total Web Inquiries', value: 'totalWebInq', class: 'black--text'},
          {text: 'Gallons', value: 'gallons', class: 'black--text'},
          {text: 'Quoted Gallons', value: 'quoted_gallons', class: 'black--text'},

          {text: 'Potential Gallons', value: 'p_gallons', class: 'black--text'},

            {text: 'Revenue', value: 'salePrice', class: 'black--text'},
          {text: 'Return', value: 'return', class: 'black--text'},
          {text: 'Orders', value: 'orders', class: 'black--text'},
          {text: 'ROI', value: 'roi', class: 'black--text'}
        ],
        valueBing: [
          {text: 'Campaign Name', value: 'campaignName', class: 'black--text'},
          {text: 'Campaign Status', value: 'campaignStatus', class: 'black--text'},
          {text: 'Impressions', value: 'impressions', class: 'black--text'},
          {text: 'Clicks', value: 'clicks', class: 'black--text'},
          {text: 'Expenses', value: 'spend', class: 'black--text'},
          {text: 'CPC', value: 'avgCpc', class: 'black--text'},
          {text: 'Conversions', value: 'conversions', class: 'black--text'},
            {text: 'ROAS', value: 'roas', class: 'black--text',sortable: true},
          {text: 'Expenses per Conversion', value: 'costPerConversion', class: 'black--text'},
          {text: 'Total Calls', value: 'totalCalls', class: 'black--text'},
          {text: 'Total Web Inquiries', value: 'totalWebInq', class: 'black--text'},
          {text: 'Gallons', value: 'gallons', class: 'black--text'},
          {text: 'Quoted Gallons', value: 'quoted_gallons', class: 'black--text'},

          {text: 'Potential Gall  ons', value: 'p_gallons', class: 'black--text'},
            {text: 'Revenue', value: 'salePrice', class: 'black--text'},
          {text: 'Return', value: 'return', class: 'black--text'},
          {text: 'Orders', value: 'orders', class: 'black--text'},
          {text: 'ROI', value: 'roi', class: 'black--text'}
        ],
        valueOther: [
          {text: 'Name', value: 'name', class: 'black--text'},
          {text: 'Admin Count Orders', value: 'countOrdersAdmin', class: 'black--text'},
          {text: 'Admin Gallons', value: 'gallonsAdmin', class: 'black--text'},
          {text: 'Admin Revenue', value: 'salePriceAdmin', class: 'black--text'},
          {text: 'User Count Orders', value: 'countOrdersUser', class: 'black--text'},
          {text: 'User Gallons', value: 'gallonsUser', class: 'black--text'},
          {text: 'User Revenue', value: 'salePriceUser', class: 'black--text'},
          {text: 'Total Count Orders',value: 'countOrdersTotal', class: 'black--text'},
          {text: 'Total Gallons',value: 'gallonsTotal', class: 'black--text'},
          {text: 'Total Calls', value: 'totalCalls', class: 'black--text'},
          {text: 'Total Web Inquiries', value: 'totalWebInq', class: 'black--text'},

          {text: 'Total Revenue',value: 'salePriceTotal', class: 'black--text'}
        ],        
        customHeaderAdwords: ['campaignName', 'campaignStatus', 'impressions', 'clicks', 'spend', 'avgCpc',
                    'conversions', 'costPerConversion', 'totalCalls','totalWebInq', 'gallons', 'salePrice', 'return', 'orders', 'roi'],
        customHeaderBing: ['campaignName', 'campaignStatus', 'impressions', 'clicks', 'spend', 'avgCpc',
                    'conversions', 'costPerConversion', 'totalCalls','totalWebInq', 'gallons', 'salePrice', 'return','orders', 'roi'],
        customHeaderOther: ['name', 'countOrdersAdmin', 'gallonsAdmin', 'salePriceAdmin', 'countOrdersUser',
                        'gallonsUser', 'salePriceUser', 'countOrdersTotal', 'gallonsTotal', 'salePriceTotal'],
        selectedHeadersAdwords: [],
        selectedHeadersBing: [],
        selectedHeadersOther: [],
        otherMode: [{text: 'Admin', value: ['name', 'countOrdersAdmin', 'gallonsAdmin', 'salePriceAdmin']}, 
                    {text: 'User', value: ['name', 'countOrdersUser', 'gallonsUser', 'salePriceUser']},
                    {text: 'Total', value: ['name', 'countOrdersTotal', 'gallonsTotal', 'salePriceTotal']}, 
                  ],
        selectedOtherMode: [],
        statistic: {
          totalOrders: 0,
          totalGallons: 0,
          totalCost: 0,
          totalSalesPrice: 0,
          ordersAdwords: 0,
          ordersBing: 0,
          ordersOther: 0,
          salesPriceAdwords: 0,
          salesPriceBing: 0,
          salesPriceOther: 0,
          costAdwords: 0,
          costBing: 0,
          costOther: 0,
          gallonsAdwords: 0,
          gallonsBing: 0,
          gallonsOther: 0
        },
        statisticCompare: {
          totalOrders: 0,
          totalGallons: 0,
          totalCost: 0,
          totalSalesPrice: 0,
          ordersAdwords: 0,
          ordersBing: 0,
          ordersOther: 0,
          salesPriceAdwords: 0,
          salesPriceBing: 0,
          salesPriceOther: 0,
          costAdwords: 0,
          costBing: 0,
          costOther: 0,
          gallonsAdwords: 0,
          gallonsBing: 0,
          gallonsOther: 0
        },
        settingsName: 'efficiencyReport',
        columnsDataBing: [],
        columnsDataAdwords: [],
        columnsDataOther: [],
        hoverOnTableAdwords: false,
        hoverOnTableBing: false,
        hoverOnTableOther: false,
        statisticСards: [
          [
            {title: 'Total Orders', value: 'totalOrders', loaded: 'loadedStatistic', filter: 'formatFloat'},
            {title: 'Orders Google Ads', value: 'ordersAdwords', loaded: 'loadedAdwords', filter: 'formatFloat'},
            {title: 'Orders Bing Ads', value: 'ordersBing', loaded: 'loadedBing', filter: 'formatFloat'},
            {title: 'Orders Other', value: 'ordersOther', loaded: 'loadedOther', filter: 'formatFloat'}
          ],
          [
            {title: 'Total Gallons', value: 'totalGallons', loaded: 'loadedStatistic', filter: 'formatFloat'},
            {title: 'Gallons Google Ads', value: 'gallonsAdwords', loaded: 'loadedAdwords', filter: 'formatFloat'},
            {title: 'Gallons Bing Ads', value: 'gallonsBing', loaded: 'loadedBing', filter: 'formatFloat'},
            {title: 'Gallons Other', value: 'gallonsOther', loaded: 'loadedOther', filter: 'formatFloat'}
          ],
          [
            {title: 'Total Expenses', value: 'totalCost', loaded: 'loadedStatistic', filter: 'formatPrice'},
            {title: 'Google Ads Expenses', value: 'costAdwords', loaded: 'loadedAdwords', filter: 'formatPrice'},
            {title: 'Bing Ads Expenses', value: 'costBing', loaded: 'loadedBing', filter: 'formatPrice'},
            {title: 'Other Expenses', value: 'costOther', loaded: 'loadedOther', filter: 'formatPrice'}
          ],
          [
            {title: 'Total Revenue', value: 'totalSalesPrice', loaded: 'loadedStatistic', filter: 'formatPrice'},
            {title: 'Google Ads Revenue', value: 'salesPriceAdwords', loaded: 'loadedAdwords', filter: 'formatPrice'},
            {title: 'Bing Ads Revenue', value: 'salesPriceBing', loaded: 'loadedBing', filter: 'formatPrice'},
            {title: 'Other Revenue', value: 'salesPriceOther', loaded: 'loadedOther', filter: 'formatPrice'},
              // {title: 'Total ROAS', value: 'totalROAS', loaded: 'loadedOther', filter: 'formatFloat'},
              {title: 'Google ROAS', value: 'googleROAS', loaded: 'loadedOther', filter: 'formatFloat'},
              {title: 'Bing ROAS', value: 'bingROAS', loaded: 'loadedOther', filter: 'formatFloat'},

          ]          
        ],
        slotsAdwordsBing: [
          {name: 'spend', filter: 'formatFloat'},
          {name: 'salePrice', filter: 'formatPrice'},
          {name: 'impressions', filter: 'formatFloat'},
          {name: 'spend', filter: 'formatPrice'},
          {name: 'costPerConversion', filter: 'formatPrice'},
          {name: 'conversions', filter: 'formatFloat'},
          {name: 'avgCpc', filter: 'formatFloat'},
          {name: 'totalCalls', filter: 'formatFloat'},
          {name: 'gallons', filter: 'formatFloat'},
          {name: 'clicks', filter: 'formatFloat'},
          {name: 'return', filter: 'formatPrice'},
          {name: 'roi', filter: 'formatFloat'},
          {name: 'orders', filter: 'formatFloat', redirect: true}
        ],
        slotsOther: [
          {name: 'gallonsAdmin', filter: 'formatFloat'},
          {name: 'gallonsUser', filter: 'formatFloat'},
          {name: 'gallonsTotal', filter: 'formatFloat'},
          {name: 'salePriceAdmin', filter: 'formatPrice'},
          {name: 'salePriceUser', filter: 'formatPrice'},
          {name: 'salePriceTotal', filter: 'formatPrice'},
          {name: 'countOrdersAdmin', filter: 'formatFloat', redirect: 'OtherAdmin'},
          {name: 'countOrdersUser', filter: 'formatFloat', redirect: 'OtherUser'},
          {name: 'countOrdersTotal', filter: 'formatFloat', redirect: 'OtherTotal'}        
        ]
      }
    },
    watch: {
      valueAdwords(val) {
        this.selectedHeadersAdwords = val
        this.getHeaderForExcel()
      },
      valueBing(val) {
        this.selectedHeadersBing = val
        this.getHeaderForExcel() 
      },
      valueOther(val) {
        this.selectedHeadersOther = val
        this.getHeaderForExcel() 
      },
      hoverOnTableAdwords(){
        this.showScrollingArrowsAdw()  
      },
      hoverOnTableBing(){
        this.showScrollingArrowsBing()
      },
      hoverOnTableOther(){
        this.showScrollingArrowsOther()
      },
      isCompareFilter(){
        if (!this.isCompareFilter){
        let d = moment(this.dateStart)
        this.dateCompareEnd = new Date(Date.UTC(
                                  new Date(d).getFullYear(),
                                  new Date(d).getMonth(),
                                  new Date(d).getDate() - 1)
                                ).toISOString().substr(0, 10)

        this.dateCompareStart = new Date(
                                  Date.UTC(
                                    new Date(d).getFullYear(),
                                    new Date(d).getMonth(),
                                    new Date(d).getDate() - this.diffDays)
                                  ).toISOString().substr(0, 10)
        } else {
          this.applayCompares()
        }
      },
      dateStart(){
        this.countDiffDayes()
        this.countDateCompareEnd()
        this.countDateCompareStart()        
      },
      dateEnd(){
        this.countDiffDayes()
        this.countDateCompareEnd()
        this.countDateCompareStart()        
      }
    },
    created() {
        this.selectedHeadersAdwords = this.valueAdwords
        this.selectedHeadersBing = this.valueBing
        this.selectedHeadersOther = this.valueOther
        this.getHeaderForExcel()
        window.addEventListener("resize", this.showScrollingArrowsAdw)
        window.addEventListener("resize", this.showScrollingArrowsBing)
        window.addEventListener("resize", this.showScrollingArrowsOther)

        this.countDiffDayes()
        this.countDateCompareEnd()
        this.countDateCompareStart()
    },
    destroyed() {
      window.removeEventListener("resize", this.showScrollingArrowsAdw)
      window.removeEventListener("resize", this.showScrollingArrowsBing)
      window.removeEventListener("resize", this.showScrollingArrowsOther)
    },
    mounted() {
        if (sessionStorage.getItem('dateStart')) {
          this.dateStart = sessionStorage.getItem('dateStart')
        }
        if (sessionStorage.getItem('dateEnd')) {
          this.dateEnd = sessionStorage.getItem('dateEnd')
        }

        this.applyFilters()
        this.applayCompares()

        let userName = localStorage.getItem('username')
        let settings = this.settingsName
        let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1

        if (localStorage.getItem(`${userName}.${clientId}.${settings}Adwords`)) {
          try {           
            let valueAdwordsCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}Adwords`))
            this.valueAdwords = valueAdwordsCash.filter(e => this.headersAdwords.find(item => item.value === e.value))
            
            const parsed = JSON.stringify(this.valueAdwords)
            localStorage.setItem(`${userName}.${clientId}.${settings}Adwords`, parsed)


            this.customHeaderAdwords = this.valueAdwords.map(e => e.value)
          } catch(e) {
            console.log("")
          }
        }

        if (localStorage.getItem(`${userName}.${clientId}.${settings}Bing`)) {        
          try {
            let valueBingCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}Bing`))
            this.valueBing = valueBingCash.filter(e => this.headersBing.find(item => item.value === e.value))
            
            const parsed = JSON.stringify(this.valueBing)
            localStorage.setItem(`${userName}.${clientId}.${settings}Bing`, parsed)

            this.customHeaderBing = this.valueBing.map(e => e.value)
          } catch(e) {
            console.log(e)
          }
        }

        if (localStorage.getItem(`${userName}.${clientId}.${settings}Other`)) {         
          try {
            let valueOtherCash = JSON.parse(localStorage.getItem(`${userName}.${clientId}.${settings}Other`))
            this.valueOther = valueOtherCash.filter(e => this.headersOther.find(item => item.value === e.value))
            
            const parsed = JSON.stringify(this.valueOther)
            localStorage.setItem(`${userName}.${clientId}.${settings}Other`, parsed)

            this.customHeaderOther = this.valueOther.map(e => e.value)
          } catch(e) {
            console.log(e)
          }
        }

      this.showScrollingArrowsAdw()
      this.showScrollingArrowsBing()
      this.showScrollingArrowsOther()
    },
  computed: {
    dataAdwordsForExcel(){
      if (!this.dataAdwords) return []
      let data = JSON.parse(JSON.stringify(this.dataAdwords))
      console.log('this.dataAdwords', data)
      data.map(e => {
        e.impressions = Math.round10(e.impressions, -2)
        e.clicks = Math.round10(e.clicks, -2)
        e.spend = Math.round10(e.spend, -2)
        e.avgCpc = Math.round10(e.avgCpc, -2)
        e.conversions = Math.round10(e.conversions, -2)
        e.costPerConversion = Math.round10(e.costPerConversion, -2)
        e.gallons = Math.round10(e.gallons, -2)
        e.salePrice = Math.round10(e.salePrice, -2)
        e.return = Math.round10(e.salePrice * 0.2, -2)
        e.orders = Math.round10(e.orders, -2)
        e.roi = Math.round10(e.roi, -1)
      })
      return data
    },
    dataBingForExcel(){
      if (!this.dataBing) return []
      let data = JSON.parse(JSON.stringify(this.dataBing))
      data.map(e => {
        e.impressions = Math.round10(e.impressions, -2)
        e.clicks = Math.round10(e.clicks, -2)
        e.spend = Math.round10(e.spend, -2)
        e.avgCpc = Math.round10(e.avgCpc, -2)
        e.conversions = Math.round10(e.conversions, -2)
        e.costPerConversion = Math.round10(e.costPerConversion, -2)
        e.gallons = Math.round10(e.gallons, -2)
        e.salePrice = Math.round10(e.salePrice, -2)
        e.return = Math.round10(e.return, -2)
        e.orders = Math.round10(e.orders, -2)
        e.roi = Math.round10(e.roi, -1)
      })
      return data
    },
    dataOtherForExcel(){
      if (!this.dataOther) return []
      let data = JSON.parse(JSON.stringify(this.dataOther))

      return data
    },
    loadedStatistic(){
      return [this.loadings.loadedAdwords, 
              this.loadings.loadedBing, 
              this.loadings.loadedOther
             ].some(e => e == true)
    },
    loadedStatisticCompare(){
      return [this.loadings.loadedAdwordsCompare, 
              this.loadings.loadedBingCompare, 
              this.loadings.loadedOtherCompare
             ].some(e => e == true)
    },    
  },
  methods: {
    countDiffDayes(){
      const oneDay = 24 * 60 * 60 * 1000
      const firstDate = new Date(this.dateStart)
      const secondDate = new Date(this.dateEnd)

      this.diffDays =  Math.round(Math.abs((firstDate - secondDate) / oneDay)) + 1
    },

    showSimpleAlert(item, type){
      this.dialogSimple = true
      this.dialogSimpleType = type
      this.selectedKeyword = item
    },


    countDateCompareEnd(){
      let d = moment(this.dateStart)

      this.dateCompareEnd = new Date(
                              Date.UTC(
                                new Date(d).getFullYear(),
                                new Date(d).getMonth(),
                                new Date(d).getDate() - 1)
                              ).toISOString().substr(0, 10)
    },
    countDateCompareStart(){
      let d = moment(this.dateStart)

      this.dateCompareStart = new Date(
                              Date.UTC(
                                new Date(d).getFullYear(),
                                new Date(d).getMonth(),
                                new Date(d).getDate() - this.diffDays)
                              ).toISOString().substr(0, 10)
    },
    scrollingRightAdw(){
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[0].scrollLeft = el[0].scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow-adw')
      const btnLeft = document.querySelector('.btn-left-arrow-adw')
      btnRight.style.visibility = (this.hoverOnTableAdwords && (el[0].scrollLeft + el[0].clientWidth != el[0].scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTableAdwords ? 'visible' : 'hidden'
    },
    scrollingLeftAdw(){
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[0].scrollLeft = el[0].scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow-adw')
      const btnRight = document.querySelector('.btn-right-arrow-adw')
      btnLeft.style.visibility = (this.hoverOnTableAdwords && (el[0].scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTableAdwords ? 'visible' : 'hidden'
    },
    scrollingRightBing(){
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[1].scrollLeft = el[1].scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow-bing')
      const btnLeft = document.querySelector('.btn-left-arrow-bing')
      btnRight.style.visibility = (this.hoverOnTableBing && (el[1].scrollLeft + el[1].clientWidth != el[1].scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTableBing ? 'visible' : 'hidden'
    },
    scrollingLeftBing(){
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[1].scrollLeft = el[1].scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow-bing')
      const btnRight = document.querySelector('.btn-right-arrow-bing')
      btnLeft.style.visibility = (this.hoverOnTableBing && (el[1].scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTableBing ? 'visible' : 'hidden'
    },
    scrollingRightOther(){
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[2].scrollLeft = el[2].scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow-other')
      const btnLeft = document.querySelector('.btn-left-arrow-other')
      btnRight.style.visibility = (this.hoverOnTableOther && (el[2].scrollLeft + el[2].clientWidth != el[2].scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTableOther ? 'visible' : 'hidden'
    },
    scrollingLeftOther(){
      const el = document.querySelectorAll('.v-data-table__wrapper')
      el[2].scrollLeft = el[2].scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow-other')
      const btnRight = document.querySelector('.btn-right-arrow-other')
      btnLeft.style.visibility = (this.hoverOnTableOther && (el[2].scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTableOther ? 'visible' : 'hidden'
    },
    showScrollingArrowsAdw(){
      const el = document.querySelectorAll('.v-data-table__wrapper')

      const btnRightAdw = document.querySelector('.btn-right-arrow-adw')
      const btnLeftAdw = document.querySelector('.btn-left-arrow-adw')
      btnRightAdw.style.visibility = (this.hoverOnTableAdwords && (el[0].scrollLeft + el[0].clientWidth !== el[0].scrollWidth)) ? 'visible' : 'hidden'
      btnLeftAdw.style.visibility = (this.hoverOnTableAdwords && (el[0].scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    showScrollingArrowsBing(){
      const el = document.querySelectorAll('.v-data-table__wrapper')

      const btnRightBing = document.querySelector('.btn-right-arrow-bing')
      const btnLeftBing = document.querySelector('.btn-left-arrow-bing')
      btnRightBing.style.visibility = (this.hoverOnTableBing && (el[1].scrollLeft + el[1].clientWidth !== el[1].scrollWidth)) ? 'visible' : 'hidden'
      btnLeftBing.style.visibility = (this.hoverOnTableBing && (el[1].scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    showScrollingArrowsOther(){
      const el = document.querySelectorAll('.v-data-table__wrapper')

      const btnRightOther = document.querySelector('.btn-right-arrow-other')
      const btnLeftOther = document.querySelector('.btn-left-arrow-other')
      btnRightOther.style.visibility = (this.hoverOnTableOther && (el[2].scrollLeft + el[2].clientWidth !== el[2].scrollWidth)) ? 'visible' : 'hidden'
      btnLeftOther.style.visibility = (this.hoverOnTableOther && (el[2].scrollLeft != 0)) ? 'visible' : 'hidden'
    },
    customSort: function (items, index, isDesc) {
      items.sort((a, b) => {
        if (typeof a[index] === 'number' && typeof b[index] === 'number') {
          if (!isDesc[0]) {
            return a[index] - b[index];
          } else {
            return b[index] - a[index]
          }
        } else {
          let av = "-"
          if (a[index] !== null && a[index] !== undefined) {
            av = a[index]
          }
          let bv = "-"
          if (b[index] !== null && b[index] !== undefined) {
            bv = b[index]
          }

          if (!isDesc[0]) {
            return av.toLowerCase().localeCompare(bv.toLowerCase());
          } else {
            return bv.toLowerCase().localeCompare(av.toLowerCase());
          }
        }
      });
      return items;
    },
    getHeaderForExcel(){
      this.columnsDataAdwords = this.selectedHeadersAdwords.map(e => {
            const obj = {}
            if (e.value !== "actions") {
              obj.label = e.text
              obj.field = e.value
            }
            if (e.value === "costPerConversion" ||
                e.value === "spend" ||
                e.value === "salePrice" ||
                e.value === "return") {
                  obj.label =`${e.text},$`
                  obj.field = e.value
                }
            return obj
        })

      this.columnsDataBing = this.selectedHeadersBing.map(e => {
            const obj = {}
            if (e.value !== "actions") {
              obj.label = e.text
              obj.field = e.value
            }
            if (e.value === "costPerConversion" ||
                e.value === "spend" ||
                e.value === "salePrice" ||
                e.value === "return") {
                  obj.label =`${e.text},$`
                  obj.field = e.value
                }
            return obj
        })

      this.columnsDataOther = this.selectedHeadersOther.map(e => {
            const obj = {}
            if (e.value !== "actions") {
              obj.label = e.text
              obj.field = e.value
            }
            if (e.value === "salePriceAdmin" || e.value === "salePriceUser") {
                  obj.label =`${e.text},$`
                  obj.field = e.value
                }
            return obj
        })
    },
    getDates({ dateStart, dateEnd, compareMode }) {
      this.dateStart = dateStart
      this.dateEnd = dateEnd
      this.isCompareFilter = compareMode
      this.pagination.page = 1
      this.applyFilters()
      this.applayCompares()
    },
    getCompareDates(dates){
      this.dateCompareStart = dates.dateStart
      this.dateCompareEnd = dates.dateEnd
      this.pagination.page = 1
      this.applyFilters()
      this.applayCompares()
    },
    applayCompares(){
      this.loadings.loadedAdwordsCompare = true
      this.loadings.loadedBingCompare = true
      this.loadings.loadedOtherCompare = true

      axios
        .get('/reports/efficiency/' + this.dateCompareStart + '/'  + this.dateCompareEnd + '/1')
        .then(response => {
          this.dataCompareAdwords = response.data.data

          this.dataAdwords.map(e => {
            let obj = this.dataCompareAdwords.find(i => i.campaignName == e.campaignName)
            if (obj) {
              e.avgCpcCompare = e.avgCpc - obj.avgCpc
              e.spendCompare = e.spend - obj.spend
              e.costPerConversionCompare = e.costPerConversion - obj.costPerConversion
              e.returnCompare = e.return - (obj.salePrice * 0.2)
              e.salePriceCompare = e.salePrice - obj.salePrice
              e.roiCompare = e.roi - Math.round10(obj.roi, -1)
              e.impressionsCompare = e.impressions - obj.impressions
              e.clicksCompare = e.clicks - obj.clicks
              e.conversionsCompare = e.conversions - obj.conversions
              e.gallonsCompare = e.gallons - obj.gallons
              e.ordersCompare = e.orders - obj.orders

            }
          })
          this.getStatisticTotalCompare()
          this.loadings.loadedAdwordsCompare = false
          this.$forceUpdate()      
      })

      axios
        .get('/reports/efficiency/' + this.dateCompareStart + '/'  + this.dateCompareEnd + '/2')
        .then(response => {
          this.dataCompareBing = response.data.data

          this.dataBing.map(e => {
            let obj = this.dataCompareBing.find(i => i.campaignName == e.campaignName)
            if (obj) {
              e.avgCpcCompare = e.avgCpc - obj.avgCpc
              e.spendCompare = e.spend - obj.spend
              e.costPerConversionCompare = e.costPerConversion - obj.costPerConversion
              e.returnCompare = e.return - (obj.salePrice * 0.2)
              e.salePriceCompare = e.salePrice - obj.salePrice
              e.roiCompare = e.roi - Math.round10(obj.roi, -1)
              e.impressionsCompare = e.impressions - obj.impressions
              e.clicksCompare = e.clicks - obj.clicks
              e.conversionsCompare = e.conversions - obj.conversions
              e.gallonsCompare = e.gallons - obj.gallons
              e.ordersCompare = e.orders - obj.orders
            }
          })
          this.getStatisticTotalCompare()
          this.loadings.loadedBingCompare = false
      })
          
      axios
        .get('/reports/efficiency/' + this.dateCompareStart + '/'  + this.dateCompareEnd + '/3')
        .then(response => {
          this.dataCompareOther = response.data.data

          this.dataOther.map(e => {
            let obj = this.dataCompareOther.find(i => i.name == e.name)
            if (obj) {
              e.countOrdersAdminCompare = e.countOrdersAdmin - obj.countOrdersAdmin
              e.countOrdersUserCompare = e.countOrdersUser - obj.countOrdersUser
              e.gallonsAdminCompare = e.gallonsAdmin - obj.gallonsAdmin
              e.gallonsUserCompare = e.gallonsUser - obj.gallonsUser
              e.salePriceAdminCompare = e.salePriceAdmin - obj.salePriceAdmin
              e.salePriceUserCompare = e.salePriceUser - obj.salePriceUser
              e.countOrdersTotalCompare = e.countOrdersTotal - (obj.countOrdersAdmin + obj.countOrdersUser)
              e.gallonsTotalCompare = e.gallonsTotal - (obj.gallonsAdmin + obj.gallonsUser)
              e.salePriceTotalCompare = e.salePriceTotal - (obj.salePriceAdmin + obj.salePriceUser)
            }
          })

          this.getStatisticTotalCompare()
          this.loadings.loadedOtherCompare = false
      })
    },
    applyFilters() {
      this.loadings.loadedAdwords = true
      this.loadings.loadedBing = true
      this.loadings.loadedOther = true

      axios
          .get('/reports/efficiency/' + this.dateStart + '/'  + this.dateEnd + '/1')
          .then(response => {
              this.dataAdwords = response.data.data
              this.dataAdwords = this.dataAdwords.map(el=> this.calcROAS_per_campaign(el) )
              this.dataAdwords.map(e => {
                e.return = e.salePrice * 0.2
                e.roi = Math.round10(e.roi, -1)
                e.campaignStatus = e.campaignStatus ==='ENABLED' ? 'Eligibled' : 'Paused'
              })
              
              this.getStatisticTotal()
              this.getStatisticTotalCompare()
              this.loadings.loadedAdwords = false
          })
      axios
          .get('/reports/efficiency/' + this.dateStart + '/'  + this.dateEnd + '/2')
          .then(response => {
              this.dataBing = response.data.data
              this.dataBing = this.dataBing.map(el=> this.calcROAS_per_campaign(el) )
              this.dataBing.map(e => {
                e.return = e.salePrice * 0.2
                e.roi = Math.round10(e.roi, -1)
                e.campaignStatus = e.campaignStatus ==='ENABLED' ? 'Eligibled' : 'Paused'
              })

              this.getStatisticTotal()
              this.getStatisticTotalCompare()
              this.loadings.loadedBing = false
          })
      axios
          .get('/reports/efficiency/' + this.dateStart + '/'  + this.dateEnd + '/3')
          .then(response => {
              this.dataOther = response.data.data
              //this.dataOther = this.dataOther.map(el=> this.calcROAS_per_campaign(el) )

              this.dataOther.map(e => {
                  if(e.adminOrderIds){
                      e.adminOrderIds = e.adminOrderIds.map(i => +i)
                  }
                e.userOrderIds = e.userOrderIds.map(i => +i)
                e.countOrdersTotal = e.countOrdersAdmin + e.countOrdersUser
                e.gallonsTotal = e.gallonsAdmin + e.gallonsUser
                e.salePriceTotal = e.salePriceAdmin + e.salePriceUser
              })

              this.getStatisticTotal()
              this.getStatisticTotalCompare()
              this.loadings.loadedOther = false
          })
    
      this.getHeaderForExcel()
    },
    getStatisticTotal(){
      let adwordsCounter = this.dataAdwords.reduce((acc, e) => {
        Object.keys(e).forEach(key => {     
          acc[key] = (acc[key] || 0) + e[key]
        })
        return acc
      }, {})
      this.statistic.ordersAdwords = adwordsCounter.orders
      this.statistic.salesPriceAdwords = adwordsCounter.salePrice
      this.statistic.costAdwords = adwordsCounter.spend
      this.statistic.gallonsAdwords = adwordsCounter.gallons

      let bingCounter = this.dataBing.reduce((acc, e) => {
        Object.keys(e).forEach(key => {     
          acc[key] = (acc[key] || 0) + e[key]
        })
        return acc
      }, {})
      this.statistic.ordersBing = bingCounter.orders
      this.statistic.salesPriceBing = bingCounter.salePrice
      this.statistic.costBing = bingCounter.spend
      this.statistic.gallonsBing = bingCounter.gallons

      let otherCounter = this.dataOther.reduce((acc, e) => {
        Object.keys(e).forEach(key => {     
          acc[key] = (acc[key] || 0) + e[key]
        })
        return acc
      }, {})
      
      this.statistic.ordersOther = Math.round10(otherCounter.countOrdersTotal, -2)
      this.statistic.salesPriceOther = Math.round10(otherCounter.salePriceTotal, -2)
      this.statistic.gallonsOther = Math.round10(otherCounter.gallonsTotal, -2)

      this.statistic.totalOrders = this.statistic.ordersAdwords + this.statistic.ordersBing + this.statistic.ordersOther
      this.statistic.totalGallons = this.statistic.gallonsAdwords + this.statistic.gallonsBing + this.statistic.gallonsOther
      this.statistic.totalCost = this.statistic.costAdwords + this.statistic.costBing
      this.statistic.totalSalesPrice = this.statistic.salesPriceAdwords + this.statistic.salesPriceBing + this.statistic.salesPriceOther
        //this.statistic.totalROAS = (this.statistic.totalSalesPrice/this.statistic.totalCost).toFixed(2)

        if((this.statistic.costAdwords)&&(this.statistic.costAdwords != 0))
          this.statistic.googleROAS = (this.statistic.salesPriceAdwords/this.statistic.costAdwords).toFixed(2)
        if ( (!this.statistic.costAdwords) ||(!this.statistic.costAdwords)) this.statistic.googleROAS = 0//'N/A'

        if ((this.statistic.costBing)&& (this.statistic.costBing != 0))
          this.statistic.bingROAS = (this.statistic.salesPriceBing/this.statistic.costBing).toFixed(2)

        if ( (!this.statistic.costBing) ||(!this.statistic.salesPriceBing)) this.statistic.bingROAS = 0//'N/A'

    },
    getStatisticTotalCompare(){
      let adwordsCounter = this.dataCompareAdwords.reduce((acc, e) => {
        Object.keys(e).forEach(key => {     
          acc[key] = (acc[key] || 0) + e[key]
        })
        return acc
      }, {})
      this.statisticCompare.ordersAdwords = Math.round10((this.statistic.ordersAdwords || 0) - (adwordsCounter.orders || 0), -2)
      this.statisticCompare.gallonsAdwords = Math.round10((this.statistic.gallonsAdwords || 0) - (adwordsCounter.gallons || 0), -2)
      this.statisticCompare.costAdwords = Math.round10((this.statistic.costAdwords || 0) - (adwordsCounter.spend || 0), -2)
      this.statisticCompare.salesPriceAdwords = Math.round10((this.statistic.salesPriceAdwords || 0) - (adwordsCounter.salePrice || 0), -2)
      

      let bingCounter = this.dataCompareBing.reduce((acc, e) => {
        Object.keys(e).forEach(key => {     
          acc[key] = (acc[key] || 0) + e[key]
        })
        return acc
      }, {})

      this.statisticCompare.ordersBing = Math.round10((this.statistic.ordersBing || 0) - (bingCounter.orders || 0), -2)
      this.statisticCompare.salesPriceBing = Math.round10((this.statistic.salesPriceBing || 0) - (bingCounter.salePrice || 0), -2)
      this.statisticCompare.costBing = Math.round10((this.statistic.costBing || 0) - (bingCounter.spend || 0), -2)
      this.statisticCompare.gallonsBing = Math.round10((this.statistic.gallonsBing || 0) - (bingCounter.gallons || 0), -2)


      let otherCounter = this.dataCompareOther.reduce((acc, e) => {
        Object.keys(e).forEach(key => {     
          acc[key] = (acc[key] || 0) + e[key]
        })
        return acc
      }, {})

      this.statisticCompare.ordersOther = Math.round10((this.statistic.ordersOther || 0) - ((otherCounter.countOrdersAdmin + otherCounter.countOrdersUser) || 0), -2)
      this.statisticCompare.gallonsOther = Math.round10((this.statistic.gallonsOther || 0) - ((otherCounter.gallonsAdmin + otherCounter.gallonsUser) || 0), -2)
      this.statisticCompare.salesPriceOther = Math.round10((this.statistic.salesPriceOther || 0) - ((otherCounter.salePriceAdmin + otherCounter.salePriceUser) || 0), -2)
      
      this.statisticCompare.totalOrders = Math.round10(this.statisticCompare.ordersAdwords + this.statisticCompare.ordersBing + this.statisticCompare.ordersOther, -2)
      this.statisticCompare.totalGallons = Math.round10(this.statisticCompare.gallonsAdwords + this.statisticCompare.gallonsBing + this.statisticCompare.gallonsOther, -2)
      this.statisticCompare.totalCost = Math.round10(this.statisticCompare.costAdwords + this.statisticCompare.costBing, -2)
      this.statisticCompare.totalSalesPrice = Math.round10(this.statisticCompare.salesPriceAdwords + this.statisticCompare.salesPriceBing + this.statisticCompare.salesPriceOther, -2)
      
    },
    getCustomDataAdwords({customHeader, value, selectedHeaders}){
      this.customHeaderAdwords = customHeader
      this.valueAdwords = value
      this.selectedHeadersAdwords = selectedHeaders
    },
    getCustomDataBing({customHeader, value, selectedHeaders}){
      this.customHeaderBing = customHeader
      this.valueBing = value
      this.selectedHeadersBing = selectedHeaders
    },
    getCustomDataOther({customHeader, value, selectedHeaders}){
      this.customHeaderOther = customHeader
      this.valueOther = value
      this.selectedHeadersOther = selectedHeaders
      this.selectedOtherMode = []
    },

    floatToString(value) {
      if (value===-1){
        return 'N/A'
      }
        return value.toFixed(2);
      },


      calcROAS_per_campaign( capmaing_data ){
        /*
        0: "avgCpc"
            1: "campaignName"
            2: "campaignStatus"
            3: "campaign_id"
            4: "clicks"
            5: "conversions"
            6: "costPerConversion"
            7: "gallons"
            8: "hubOrderIds"
            9: "impressions"
            10: "orders"
            11: "p_gallons"
            12: "roi"
            13: "salePrice"
            14: "spend"
         */

        capmaing_data['roas'] = ( capmaing_data['salePrice']/capmaing_data['spend'] ) // .toFixed(2)
          if (capmaing_data['spend'] == 0){
              capmaing_data['roas'] = -1
          }
          return capmaing_data
      },
    rowClick: function (item, row) {     
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    },
    redirectToSalesReport(item, reportType){
      let orderIds
      switch (reportType) {
        case 'Bing':
        case 'Adwords':
          orderIds = item.hubOrderIds
          break
        case 'OtherAdmin':
          orderIds = item.adminOrderIds
          break
        case 'OtherUser':
          orderIds = item.userOrderIds
          break
        case 'OtherTotal':
          orderIds = [...item.adminOrderIds, ...item.userOrderIds]
          break        
      }

      let orders = JSON.stringify({report: `efficiencyReport${reportType}`,
                                  order_ids: orderIds,
                                  dateStart: this.dateStart,
                                  dateEnd: this.dateEnd,
                                  defaultPeriod: this.defaultPeriod})
      localStorage.setItem('orders', orders)
      let routeData = this.$router.resolve({ name: 'sales'})
      window.open(routeData.href, '_blank')
    },

      handlerClickCampaingName(nameCampaing){
        console.log('oncline', nameCampaing);
          let url = "#/keyword-attribution";
          let urlargs = 'campaignName='+nameCampaing +'&'
          +'startdate=' + this.dateStart + '&'
          +'enddate='+ this.dateEnd;
          /*
          let args =JSON.stringify(  {
              campaignName:nameCampaing,
              startdate:this.dateStart,
              enddate:this.dateEnd,
          });

          sessionStorage.setItem('keyword-attribution-args',args)*/
          url = url +'?'+urlargs
          window.open(url, '_blank', 'noreferrer');
      },

    changeOtherMode(){
      let mode = this.selectedOtherMode.flat()

      this.selectedHeadersOther = (mode.length == 0) ? this.valueOther : this.valueOther.filter(s => mode.includes(s.value))
      this.customHeaderOther = mode
    }
  }
}
</script>

<style scoped>
  .btn-right-arrow-adw,
  .btn-right-arrow-bing,
  .btn-right-arrow-other {
    right: 0px;
    top: 90px;
  }
  .btn-left-arrow-adw,
  .btn-left-arrow-bing,
  .btn-left-arrow-other {
    left: 0px;
    top: 90px;
  }
  .compare-text {
    font-size: 0.87em !important;
  }
  .compare-icon {
    font-size: 0.95em !important;
  }
  .btn-link{
      color:	#3c78d8  ;
      text-decoration: underline;
  }
</style>
